import { configureStore } from '@reduxjs/toolkit';
import userReducer from './reducers/userReducer';
import spinnerReducer from './reducers/spinnerReducer';
import brandReducer from './reducers/brandReducer';
import agencyReducer from './reducers/agencyReducer';
import themeReducer from './reducers/themeReducer';
import formoptionsReducer from './reducers/formoptionsReducer';
import formReducer from './reducers/formReducer';
import searchReducer from './reducers/searchReducer';

const store = configureStore({
  reducer: {
    user: userReducer,
    spinner: spinnerReducer,
    brand: brandReducer,
    theme: themeReducer,
    formoptions: formoptionsReducer,
    form: formReducer,
    search: searchReducer,
    agency: agencyReducer,
  },
});

export default store;